import React, { Component } from 'react'
import ConferenceHeader from './ConferenceHeader'
import ConferenceBody from './ConferenceBody'
import { connect } from 'react-redux'
import { post, get } from '../../service/index'
import Loader from '../../components/Loader/Loader'
import './Conference.css'

class Conference extends Component {

  constructor(props) {
    super(props)

    this.state = {
      treeData: {},
      loading: true,
    }
  }


  componentDidMount = async () => {
    const { token } = this.props.login.user
    const { id: conference_id } = this.props.match.params
    try {
      const getTree = await get('/get_detail_conference/' + conference_id, token)
      this.setState({ treeData: getTree, loading: false })
    } catch (err) {

    }
  }

  componentWillMount = () => {
    const { isLogin } = this.props.login
    if (!isLogin) {
      this.props.history.push('/login')
    }
  }

  render() {
    const { id } = this.props.match.params
    return (
      this.state.loading ? <Loader /> :
        <div>
          <ConferenceHeader {...this.props.location.state} conference_id={id} {...this.state.treeData} />
          <ConferenceBody {...this.props.location.state} conference_id={id} {...this.state.treeData} />


        </div>
    )
  }

}

const mapStateToProps = (state) => ({
  login: state.login
})

export default connect(mapStateToProps)(Conference)




// WEBPACK FOOTER //
// ./src/pages/Conference/Conference.js